<template>
  <div>
    <article class="m-card-element m-card-element-design-3 m-card-primary">

      <div class="m-card-element-info-data">
        <div
          v-if="!showVideo"
          class="m-card-element-design-3-video"
          @click="playVideo"
        >
          <img
            v-if="element.tarjeta.metadata.url_thumbnail"
            :alt="element.descripcion.nombre"
            :class="showMetadataValidationError && !isMetadataValid ? 'm-card-element-edition-image-error' : ''"
            :src="element.tarjeta.metadata.url_thumbnail"
            ref="imagen"
          >
          <img
            v-else
            :alt="element.descripcion.nombre"
            :class="showMetadataValidationError && !isMetadataValid ? 'm-card-element-edition-image-error' : ''"
            src="@/assets/img/ds3.png"
            ref="imagen"
          >
          <i
            v-if="element.tarjeta.metadata.url_thumbnail"
            class="far fa-play-circle m-card-element-design-3-icon"
          >
          </i>
        </div>
        <iframe
          v-else
          :id="element.tarjeta.metadata.url_video"
          :src="videoUrlParsed"
          ref="imagen"
        >
        </iframe>

        <h5
          v-if="element.descripcion.categoria !== undefined"
          key="categoryName"
        >
          {{ productoCategoriaNombre }}
        </h5>
        <h5
          v-else
          key="noCategoryName"
        >
          {{ $t('mFeedSectionContentCardDesing2.noCategoryName') }}
        </h5>

        <textarea
          :class="$v.element.descripcion.nombre.$error ? 'm-card-element-design-3-name a-input-danger' : 'm-card-element-design-3-name'"
          name="nombre"
          spellcheck="false"
          :value="element.descripcion.nombre"
          ref="nombre"
          @blur="changeElementNombre"
        >
        </textarea>
      </div>

      <div class="m-card-element-info-state">
        <div class="m-card-element-info-state-of-access">
          <h3
            v-if="element.estado.activo"
            key="available"
          >
          {{ $t('mFeedSectionContentCardDesing2.available') }}
          </h3>
          <h3
            v-else
            key="notAvailable"
          >
            {{ $t('mFeedSectionContentCardDesing2.notAvailable') }}
          </h3>
          <h4
            v-if="element.estado.visible"
            key="visible"
          >
            {{ $t('mFeedSectionContentCardDesing2.visible') }}
          </h4>
          <h4
            v-else
            key="hidden"
          >
            {{ $t('mFeedSectionContentCardDesing2.hidden') }}
          </h4>
        </div>
        <router-link
          class="m-card-element-info-state-of-price"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
        >
          {{ productoPrecio }}
        </router-link>
      </div>

    </article>

    <p v-if="isAProductRoute">
      <a
        class="font-weight-bold text-link-hover-products"
        @click.prevent="changeCardType"
      >
        <i class="far fa-window-maximize margin-right-xsmall"></i>
        {{ $t('mEditionProductCard.selectCardTypes') }}
      </a>
    </p>

    <ul>
      <li>
        <small
          v-if="$v.element.descripcion.nombre.$error"
          class="text-color-danger"
        >
          {{ messageErrorNombre }}
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign3.messages.nameLength') }}</i>
        </small>
      </li>
    </ul>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedSectionContentCardEditionDesign3',

  props: {
    element: Object,
    esPago: Boolean,
    elementCategorias: Array,
    showMetadataValidationError: Boolean,
    videoUrlParsed: {
      type: [String, Boolean],
      default: false
    }
  },

  data () {
    return {
      isMetadataValid: true,
      showVideo: false,
      tarjeta: {
        tipo: 3,
        metadata: {
          url_thumbnail: '',
          url_video: ''
        }
      }
    }
  },

  validations: {
    element: {
      descripcion: {
        nombre: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    isAProductRoute () {
      return this.$route.name === 'products' || this.$route.name === 'product'
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mFeedSectionContentCardEditionDesign3', this.$v.element.descripcion.nombre, 'nombre')
    },

    productoCategoriaNombre () {
      return this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.descripcion.categoria).nombre
    },

    productoPrecio () {
      return this.esPago
        ? this.$t('mFeedSectionContentCardEditionDesign3.infoPrice.buy')
        : this.$t('mFeedSectionContentCardEditionDesign3.infoPrice.free')
    }
  },

  watch: {
    showMetadataValidationError () {
      if (this.showMetadataValidationError) {
        this.isMetadataValid = this.tarjeta.metadata.url_video !== ''
      }
    },

    'element.tarjeta.metadata': {
      deep: true,

      handler () {
        this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta.tipo,
          metadata: Object.assign({}, this.element.tarjeta.metadata) })
        this.getValidationError()
      }
    }
  },

  created () {
    if (this.element.tarjeta.tipo === 3 && this.element.tarjeta.metadata) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta.tipo,
        metadata: Object.assign({}, this.element.tarjeta.metadata) })
    }

    this.getValidationError()
  },

  mounted () {
    this.getReference()
  },

  methods: {
    changeCardType () {
      this.$emit('changeCardType', this.tarjeta.tipo)
    },

    changeElementNombre (event) {
      this.$v.element.descripcion.nombre.$touch()
      this.$emit('changeElementNombre', event.target.value)
      this.$emit('getValidationError', 'name', this.$v.$invalid)
      this.getReference()
    },

    getReference () {
      this.$emit('getReference', 'nombre', this.$refs.nombre)
      this.$emit('getReference', 'imagen', this.$refs.imagen)
    },

    getValidationError () {
      this.isMetadataValid = this.tarjeta.metadata.url_video !== ''
      this.$emit('getValidationError', 'card', !this.isMetadataValid)
      this.getReference()
    },

    playVideo () {
      if (this.element.tarjeta.metadata.url_video.length) {
        this.showVideo = true

        setTimeout(() => {
          document.getElementById(this.element.tarjeta.metadata.url_video).src += '&autoplay=1'
        }, 1200)
      }
    }
  }
}
</script>
